import styled from 'styled-components';

export const BoxModal = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  width: 400px;
`;

export const TitleModal = styled.h6`
  font-weight: bold;
  color: #000;
  text-align: center;
`;

export const AreaButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

